"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSfilter = exports.getDistrictOptionsFromSearchSet = exports.searchSetToHfilter = void 0;
var effects_1 = require("redux-saga/effects");
var searchResponseToResultPage_1 = require("@/transformers/searchResponseToResultPage");
var SfilterKeywordAction_1 = require("@/pages/search/actions/sfilter/SfilterKeywordAction");
var SfilterDistrictAction_1 = require("@/pages/search/actions/sfilter/SfilterDistrictAction");
var SfilterPriceAction_1 = require("@/pages/search/actions/sfilter/SfilterPriceAction");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var SfilterSizeAction_1 = require("@/pages/search/actions/sfilter/SfilterSizeAction");
var searchQueryToUrl_1 = require("@/transformers/searchQueryToUrl");
var SfilterBedAction_1 = require("@/pages/search/actions/sfilter/SfilterBedAction");
var SfilterAmenityAction_1 = require("@/pages/search/actions/sfilter/SfilterAmenityAction");
var SfilterSortAction_1 = require("@/pages/search/actions/sfilter/SfilterSortAction");
var SfilterState_init_1 = require("@/pages/common/states/sfilter/SfilterState.init");
var SfilterLayoutAction_1 = require("@/pages/search/actions/sfilter/SfilterLayoutAction");
var toLayoutId_1 = require("@/transformers/toLayoutId");
var HfilterState_init_1 = require("@/pages/search/states/HfilterState.init");
var HfilterReducer_1 = require("@/pages/search/reducers/HfilterReducer");
var HfilterAction_1 = require("@/pages/search/actions/HfilterAction");
var sortOptionToSortInfo_1 = require("@/transformers/sortOptionToSortInfo");
var searchSetToHfilter = function (searchSet, currentHfilter) {
    var s = currentHfilter || HfilterState_init_1.defaultHfilterState;
    var newSfilterState = __assign(__assign({}, s), { listingType: HfilterReducer_1.hfilterReducer(s, HfilterAction_1.default.onListingTypeSelect(searchSet.listingTypeId)).listingType, keyword: HfilterReducer_1.hfilterReducer(s, HfilterAction_1.default.setKeyword(searchSet.keyword)).keyword });
    {
        var selectedIds = (searchSet.district || '').split(',').map(function (it) { return Number(it.trim()); }).filter(function (it) { return it; });
        selectedIds.map(function (it) {
            newSfilterState.districts = HfilterReducer_1.hfilterReducer(newSfilterState, HfilterAction_1.default.setDistrictActive(it, true)).districts;
        });
    }
    {
        var layoutIds = searchSet.layout ? searchSet.layout.split(',').map(function (it) { return Number(("" + it).trim()); }) : [];
        layoutIds.map(function (it) {
            newSfilterState.typeOptions = HfilterReducer_1.hfilterReducer(newSfilterState, HfilterAction_1.default.onTypeClick({ value: it })).typeOptions;
        });
    }
    {
        var priceMin = searchSet.listingTypeId === SfilterTypeGroup_1.ListingPurposeType.Sale ? searchSet.priceMin * 10000 : searchSet.priceMin;
        var priceMax = searchSet.listingTypeId === SfilterTypeGroup_1.ListingPurposeType.Sale ? searchSet.priceMax * 10000 : searchSet.priceMax;
        newSfilterState.priceMin = HfilterReducer_1.hfilterReducer(s, HfilterAction_1.default.onPriceMinChanged(priceMin)).priceMin;
        newSfilterState.priceMax = HfilterReducer_1.hfilterReducer(s, HfilterAction_1.default.onPriceMaxChanged(priceMax)).priceMax;
    }
    {
        newSfilterState.sizeMin = HfilterReducer_1.hfilterReducer(s, HfilterAction_1.default.onSizeMinChanged(searchSet.sizeMin)).sizeMin;
        newSfilterState.sizeMax = HfilterReducer_1.hfilterReducer(s, HfilterAction_1.default.onSizeMaxChanged(searchSet.sizeMax)).sizeMax;
    }
    {
        var bedPreset = s.bedsPresets.find(function (it) { return it.from === searchSet.bedroomMin && it.to === searchSet.bedroomMax; });
        if (!bedPreset && searchSet.bedroomMin === 0 && searchSet.bedroomMax === 0) {
            bedPreset = s.bedsPresets.find(function (it) { return it.from === 0; });
        }
        if (bedPreset) {
            newSfilterState.bedsPresets = HfilterReducer_1.hfilterReducer(s, HfilterAction_1.default.onBedPresetClick(bedPreset)).bedsPresets;
        }
    }
    {
        if (searchSet.hasMaidRoom) {
            var amenityOption = s.amenityOptions.find(function (it) { return it.value === 2; });
            newSfilterState.amenityOptions = HfilterReducer_1.hfilterReducer(s, HfilterAction_1.default.onAmenityClick(amenityOption)).amenityOptions;
        }
        if (searchSet.hasParking) {
            var amenityOption = s.amenityOptions.find(function (it) { return it.value === 1; });
            newSfilterState.amenityOptions = HfilterReducer_1.hfilterReducer(s, HfilterAction_1.default.onAmenityClick(amenityOption)).amenityOptions;
        }
        if (searchSet.hasOutdoorSpace) {
            var amenityOption = s.amenityOptions.find(function (it) { return it.value === 3; });
            newSfilterState.amenityOptions = HfilterReducer_1.hfilterReducer(s, HfilterAction_1.default.onAmenityClick(amenityOption)).amenityOptions;
        }
    }
    {
        var sortOption = s.sortOptions.find(function (it) { return it.value === sortOptionToSortInfo_1.sortInfoToSortOptionValue(searchSet.sortBy, searchSet.orderBy); });
        newSfilterState.sortOptions = HfilterReducer_1.hfilterReducer(s, HfilterAction_1.default.onSortOptionClicked(sortOption)).sortOptions;
    }
    return newSfilterState;
};
exports.searchSetToHfilter = searchSetToHfilter;
var getDistrictOptionsFromSearchSet = function (searchSet, currentSfilter) {
    var sfilter = currentSfilter || SfilterState_init_1.defaultSFilterState;
    var selectedIds = (searchSet.district || '').split(',').map(function (it) { return Number(it.trim()); }).filter(function (it) { return it; });
    sfilter.district.options = sfilter.district.options.map(function (it) {
        it.selected = selectedIds.indexOf(it.id) >= 0;
        return it;
    });
    sfilter.district.options = sfilter.district.options.map(function (it) {
        if (it.parent !== 0)
            return it;
        var hasMissing = sfilter.district.options.filter(function (o) { return o.parent === it.id; })
            .filter(function (it) { return !it.selected; }).length > 0 ? true : false;
        it.selected = !hasMissing;
        return it;
    });
    return sfilter.district.options;
};
exports.getDistrictOptionsFromSearchSet = getDistrictOptionsFromSearchSet;
var getPriceMinMax = function (searchSet) {
    var min = searchSet.priceMin;
    var max = searchSet.priceMax;
    if (searchResponseToResultPage_1.listTypeIdMap[searchSet.listingTypeId] === SfilterTypeGroup_1.SfilterType.BUY) {
        min = min * 10000;
        max = max * 10000;
    }
    if (!max)
        max = -1;
    return { min: min, max: max };
};
var updateSfilter = function (searchSet, sfilter) {
    var districtOptions, i, it, selectedLayoutKeys, layoutOptions, _loop_1, i, _a, min, max, sortBy_1, orderBy_1, id;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: 
            // yield put(SfilterTypeAction.changeType(listTypeIdMap[searchSet.listingTypeId]));
            return [4 /*yield*/, effects_1.put(SfilterKeywordAction_1.default.changeFilterKeyword(searchSet.keyword))];
            case 1:
                // yield put(SfilterTypeAction.changeType(listTypeIdMap[searchSet.listingTypeId]));
                _b.sent();
                districtOptions = getDistrictOptionsFromSearchSet(searchSet);
                i = 0;
                _b.label = 2;
            case 2:
                if (!(i < districtOptions.length)) return [3 /*break*/, 5];
                it = districtOptions[i];
                return [4 /*yield*/, effects_1.put(SfilterDistrictAction_1.default.changeDistrict(it.id, it.selected))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4:
                i = i + 1;
                return [3 /*break*/, 2];
            case 5:
                selectedLayoutKeys = searchSet.layout ? searchSet.layout.split(',').map(function (it) { return Number(("" + it).trim()); }).map(toLayoutId_1.fromLayoutId) : [];
                layoutOptions = sfilter.layout.options;
                _loop_1 = function (i) {
                    var layoutOption, isSelected;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                layoutOption = layoutOptions[i];
                                isSelected = selectedLayoutKeys.findIndex(function (it) { return layoutOption.key === it; }) >= 0;
                                return [4 /*yield*/, effects_1.put(SfilterLayoutAction_1.default.changeLayoutOption(layoutOption.key, isSelected))];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                i = 0;
                _b.label = 6;
            case 6:
                if (!(i < layoutOptions.length)) return [3 /*break*/, 9];
                return [5 /*yield**/, _loop_1(i)];
            case 7:
                _b.sent();
                _b.label = 8;
            case 8:
                i = i + 1;
                return [3 /*break*/, 6];
            case 9:
                if (!selectedLayoutKeys.length) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.put(SfilterLayoutAction_1.default.toggleLayoutSection(true))];
            case 10:
                _b.sent();
                _b.label = 11;
            case 11: return [4 /*yield*/, effects_1.put(SfilterPriceAction_1.default.setMode(searchResponseToResultPage_1.listTypeIdMap[searchSet.listingTypeId]))];
            case 12:
                _b.sent();
                return [4 /*yield*/, effects_1.put(SfilterPriceAction_1.default.setCurrency(searchSet.currencyId))];
            case 13:
                _b.sent();
                return [4 /*yield*/, effects_1.put(SfilterPriceAction_1.default.setPriceRangeSelected(-1, -1))];
            case 14:
                _b.sent();
                return [4 /*yield*/, effects_1.put(SfilterPriceAction_1.default.setCustomPriceVisible(false))];
            case 15:
                _b.sent();
                if (!(searchSet.priceMin !== 0 || searchSet.priceMax !== 0)) return [3 /*break*/, 18];
                return [4 /*yield*/, effects_1.put(SfilterPriceAction_1.default.setCustomPriceVisible(true))];
            case 16:
                _b.sent();
                _a = getPriceMinMax(searchSet), min = _a.min, max = _a.max;
                return [4 /*yield*/, effects_1.put(SfilterPriceAction_1.default.setPriceRangeCustom(min, max))];
            case 17:
                _b.sent();
                _b.label = 18;
            case 18: return [4 /*yield*/, effects_1.put(SfilterSizeAction_1.default.changeSizeType(searchQueryToUrl_1.sizetypeRevMap[searchSet.sizeType]))];
            case 19:
                _b.sent();
                return [4 /*yield*/, effects_1.put(SfilterSizeAction_1.default.changeSizeRange(-1, -1))];
            case 20:
                _b.sent();
                return [4 /*yield*/, effects_1.put(SfilterSizeAction_1.default.changeCustomSize(false))];
            case 21:
                _b.sent();
                if (!(searchSet.sizeMin !== 0 || searchSet.sizeMax !== 0)) return [3 /*break*/, 24];
                return [4 /*yield*/, effects_1.put(SfilterSizeAction_1.default.changeCustomSize(true))];
            case 22:
                _b.sent();
                if (!searchSet.sizeMax)
                    searchSet.sizeMax = -1;
                return [4 /*yield*/, effects_1.put(SfilterSizeAction_1.default.setCustomSize(searchSet.sizeMin, searchSet.sizeMax))];
            case 23:
                _b.sent();
                _b.label = 24;
            case 24: return [4 /*yield*/, effects_1.put(SfilterBedAction_1.default.selectBedOption(-1))];
            case 25:
                _b.sent();
                if (!(searchSet.bedroomMin === 0 && searchSet.bedroomMax === 0)) return [3 /*break*/, 27];
                return [4 /*yield*/, effects_1.put(SfilterBedAction_1.default.selectBedOption(0))];
            case 26:
                _b.sent();
                _b.label = 27;
            case 27:
                if (!(searchSet.bedroomMin > 0)) return [3 /*break*/, 29];
                return [4 /*yield*/, effects_1.put(SfilterBedAction_1.default.selectBedOption(searchSet.bedroomMin))];
            case 28:
                _b.sent();
                _b.label = 29;
            case 29: return [4 /*yield*/, effects_1.put(SfilterAmenityAction_1.default.changeAmenityOption('maid-room', searchSet.hasMaidRoom))];
            case 30:
                _b.sent();
                return [4 /*yield*/, effects_1.put(SfilterAmenityAction_1.default.changeAmenityOption('carpark', searchSet.hasParking))];
            case 31:
                _b.sent();
                return [4 /*yield*/, effects_1.put(SfilterAmenityAction_1.default.changeAmenityOption('outdoor-space', searchSet.hasOutdoorSpace))];
            case 32:
                _b.sent();
                sortBy_1 = searchSet.sortBy;
                orderBy_1 = searchSet.orderBy;
                id = sfilter.sort.options
                    .filter(function (it) { return it.order.toLowerCase() === orderBy_1.toLowerCase() && it.key === sortBy_1; })[0].id;
                return [4 /*yield*/, effects_1.put(SfilterSortAction_1.default.onChangeSort(id))];
            case 33:
                _b.sent();
                return [2 /*return*/];
        }
    });
};
exports.updateSfilter = updateSfilter;
